enum VIRTUAL_KEYBOARD_ACTIONS {
  CUSTOM,
  DELETE,
  SEARCH,
  WRITE
}

export default VIRTUAL_KEYBOARD_ACTIONS;
